<template>
    <div class="flex items-center">
        <div class="flex w-full bg-gray-800 rounded shadow mh-36">
            <slot/>
            <input class="relative w-full px-6 py-3 rounded-r focus:shadow-outline" autocomplete="off" type="text" name="search"
                   :placeholder="$t('Search')" :value="value" @input="$emit('input', $event.target.value)">
        </div>
        <button class="ml-3 text-sm text-gray-400 hover:text-gray-700 focus:text-indigo-500" type="button"
                @click="$emit('reset')">{{ $t('Reset') }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        maxWidth: {
            type: Number,
            default: 300,
        },
        disableFilter: {
            type: Boolean,
            default: false
        }
    },
}
</script>
<style scoped>
.mh-36 {
    max-height: 36px;
}
</style>
